<template>
  <b-modal
    ref="modal"
    :cancel-variant="data.cancelVariant || undefined"
    :header-bg-variant="data.headerBgVariant || undefined"
    :footer-bg-variant="data.footerBgVariant || undefined"
    :header-text-variant="data.headerTextVariant || undefined"
    :size="data.size || 'md'"
    :title="_trans('Render Farm Manager')"
    :centered="data.centered || false"
    :scrollable="data.scrollable || false"
    :no-close-on-backdrop="data.noCloseOnBackdrop || false"
    :no-close-on-esc="data.noCloseOnEsc || false"
    @hide="hide"
    @hidden="onClose"
    @shown="onShow"
  >
    <template slot="modal-header-close">
      <b-button
        size="sm"
        variant="primary"
        class="ni ni-close"
        @click="close()"
      >
      </b-button>
    </template>
    <input
      v-model="renderName"
      type="text"
      class="form-control"
      :placeholder="_trans('Render name')"
      @keyup.enter="sendRender"
    />
        <b-row class="mt-3">
          <div class="form-inline form-group col">
            <label>
              <b-form-radio v-model="renderType" class="radio-inline" :value="1" />
              <span v-text="_trans('Static image')"></span>
            </label>
          </div>
        </b-row>
    <div slot="modal-footer">
      <b-button
        variant="primary"
        @click="sendRender()"
        v-html="_trans('Send render')"
      ></b-button>
    </div>
  </b-modal>
</template>
<script>
import dModalRenderfarm from "@dialogs/modalRenderfarm";
export default {
    mixins: [dModalRenderfarm]
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/custom/epoq/dialogs/modalRenderfarm.vue